import React, { FC } from 'react';
import { LicensesTable } from '../LicensesTable/LicensesTable';
import { useIsPixotopeUser } from '../../hooks/useIsAdmin';

export const UserLicenses: FC = () => {
  const isAdmin = useIsPixotopeUser();

  return <LicensesTable showAssignedTo={false} showId={isAdmin} />;
};
